var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("ItpButton", {
        staticClass: "async-command",
        attrs: {
          type: _vm.type,
          form: _vm.form,
          text: _vm.text,
          icon: _vm.icon,
          variant: _vm.variant,
          spinning: _vm.poller.isRunning,
          disabled: _vm.disabled,
          size: _vm.size,
          tooltip: _vm.tooltip,
          block: _vm.block,
          dropdownItem: _vm.dropdownItem,
          "dropdown-stays-open-on-click": ""
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.evh_7315092382398562_clickPreventStop($event, {})
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }